import dayjs from "dayjs";
import { PickersDay } from "@mui/x-date-pickers/PickersDay";

const HighlightedPickersDay = ({ day, highlightedDates, ...props }) => {
  const isHighlighted = highlightedDates?.includes(dayjs(day).format("YYYY-MM-DD"));
  return (
    <PickersDay
      {...props}
      day={day}
      sx={isHighlighted ? {
        position: "relative",
        "&:not(.Mui-selected)": {
          backgroundColor: "rgba(16,69,129,0.10)",
          color: "#104581",
          fontWeight: 700,
        },
        "&::after": {
          content: '""',
          position: "absolute",
          bottom: "2px",
          left: "50%",
          transform: "translateX(-50%)",
          width: "5px",
          height: "5px",
          borderRadius: "50%",
          backgroundColor: "#104581",
        },
      } : {}}
    />
  );
};

export default HighlightedPickersDay;
